import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import { Box } from "@mui/material";
import { Button, Typography } from "@platform/design-system";
import { JSX } from "react";

interface Props {
  handleAction: VoidFunction;
}

const RfpError = ({ handleAction }: Props): JSX.Element => (
  <Box
    sx={{
      top: "50%",
      position: "absolute",
      left: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
    }}
  >
    <ReportGmailerrorredIcon sx={{ fontSize: 64 }} color="brandPrimary" />
    <Typography mt={3} variant="display-small">
      Your request could not be submitted
    </Typography>
    <Typography variant="body-large" display="block" my={2}>
      Don&apos;t worry, we&apos;ve saved your RFP progress. Please go back and
      try again—
    </Typography>
    <Button onClick={handleAction} variant="primary">
      Back to your rfp
    </Button>
    <Typography variant="body-medium" display="block" mt={3}>
      If the problem persists, please email us at{" "}
      <Typography variant="body-medium" component="span" color="brandPrimary">
        <strong>help@centrobenefits.com</strong>
      </Typography>
    </Typography>
  </Box>
);

export default RfpError;
